module.exports = __webpack_public_path__ + "img/z-about-img4.3473a93d.jpg";